import { deleteParkingWhiteList } from '@esentai/core/features/parkingWhitelist/actions';
import { connect } from 'react-redux';

import { retryFetch } from '@/features/parkingWhitelistGroupDetailsPage/actions';

import BulkActionsRow from './component';

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch, { selectedItems, deselectAll }) => ({
  deleteWhitelist: () => {
    selectedItems.forEach(id => dispatch(deleteParkingWhiteList(id)));
    deselectAll();
    setTimeout(() => dispatch(retryFetch()), 400);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(BulkActionsRow);
